import { createSlice } from '@reduxjs/toolkit';
import { addLogo, fetchLogos, removeLogo } from '../actions/logos-actions';
import { Status } from '../../helpers/consts/status';

const initialState = {
  status: Status.IDLE,
  logos: [],
  count: 0,
};

const logosSlice = createSlice({
  name: 'logos',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchLogos.pending, (state, action) => {
        state.status = Status.LOADING;
      })
      .addCase(fetchLogos.fulfilled, (state, action) => {
        const logos = action.payload;
        state.logos = logos;
        state.isLoading = false;
        state.status = Status.COMPLETED;
      })
      .addCase(fetchLogos.rejected, (state, action) => {
        
      })
      .addCase(addLogo.fulfilled, (state, action) => {
        const newLogo = action.payload;
        state.logos.push(newLogo);
      })
      .addCase(removeLogo.fulfilled, (state, action) => {
        const logoId = action.payload;

        state.logos = state.logos.filter(
          (logo) => logo.id !== logoId
        );
      })
  },
});

export const logosActions = logosSlice.actions;

export default logosSlice;
